<template>
  <div class="container">
    <!--  搜索  -->
    <search-bar :isCallback="true" v-model="params.name" :index="0" @doSearch="(v)=>{params.name=v;queryPageList()}"></search-bar>
    <!--  课程筛选  -->
    <course-filter
        :courseClassifyOne="params.classifyLevelOne"
        :courseClassifyTwo="params.classifyLevelTwo"
        @classifyLevelOne="(v,j)=>{params.classifyLevelOne=v;params.classifyLevelTwo=j;queryPageList()}"
        @classifyLevelTwo="(v,j)=>{params.classifyLevelTwo=v;params.classifyLevelOne=j;queryPageList()}"
        @gradeData="(v)=>{params.classifyLevelGrade=v;queryPageList()}"></course-filter>

    <!--  条件筛选  -->
    <filters @change1="(v)=>{params.isGood=v;queryPageList()}"
             @change2="(v)=>{params.isFree=v;queryPageList()}"
             @change3="(v)=>{params.studyCountSort=v;queryPageList()}"
             @change4="(v)=>{params.priceSort=v;queryPageList()}"></filters>

    <!--  数据列表  -->
    <div class="g-flex g-row-center">
      <div class="total-width g-flex g-flex-wrap " style="min-height: 500px" v-loading="loading">
        <div class="g-m-t-10 g-m-r-10" v-for="item in data">
          <course-card :data="item"></course-card>
        </div>
      </div>
    </div>
    <!--  分页  -->
    <div class="g-flex g-row-center g-m-t-30">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="params.current"
          :page-sizes="[12, 24, 50]"
          :page-size="12"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/search-bar";
import CourseFilter from "@/components/course-filter";
import Filters from "@/components/filters";
import CourseCard from "@/views/course-list/components/course-card";
import {getPageList} from '@/api/education/course'

export default {
  name: "course-list",
  components: {CourseCard, Filters, CourseFilter, SearchBar},
  data() {
    return {
      data: [],
      total: 1,
      loading: false,
      params: {
        size: 12,
        current: 1,
        name: null,
        classifyLevelGrade: null,
        classifyLevelOne: null,
        classifyLevelTwo: null,
        isGood: null,
        isFree: null,
        studyCountSort: null,
        priceSort: null,
      },
    }
  },
  created() {
    if(this.$route.query.s){
      this.params.name =this.$route.query.s
    }
    this.params.classifyLevelOne = this.$route.query.courseClassifyOne
    this.params.classifyLevelTwo = this.$route.query.courseClassifyTwo
    this.queryPageList()
  },
  methods: {
    queryPageList() {
      this.loading = true
      getPageList(this.params).then(res => {
        this.data = res.records
        this.total = res.total
        this.loading = false
      }, error => {
        this.loading = false

      })

    },
    // 页数切换
    handleSizeChange(val) {
      this.params.size = val
      this.queryPageList()
    },
    // 当前页切换
    handleCurrentChange(val) {
      this.params.current = val
      this.queryPageList()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
